module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-toyota.3bb5a421.jpg";